module.exports = __webpack_public_path__ + "static/media/shap.b41f1706.png";